// API Configuration - All endpoints go to brookmar-api
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://emailinsight-brookmar-api-6qfcvo5xza-uc.a.run.app';

export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

export default API_BASE_URL;
